/**
 * Timestamps arrive in two shapes: SQLite's `datetime('now')` ("2026-07-31
 * 17:11:00", UTC, no marker) and the importer's ISO-8601 with offset
 * ("2026-07-31T14:05:59+00:00"). Naively appending 'Z' breaks the second —
 * that bug shipped as "Invalid Date" under every imported page title.
 */
function parse(ts) {
  if (!ts) return null
  const s = String(ts)
  const iso = s.includes('T') ? s : s.replace(' ', 'T') + 'Z'
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? null : d
}

export function fmtDate(ts) {
  const d = parse(ts)
  return d ? d.toLocaleDateString() : ''
}

/** "Sep 26, 2026" — a date that reads the same on every device locale. */
export function fmtDayMedium(ts) {
  const d = parse(ts)
  return d ? d.toLocaleDateString([], { dateStyle: 'medium' }) : ''
}

export function fmtDateTime(ts) {
  const d = parse(ts)
  return d ? d.toLocaleString([], { dateStyle: 'medium', timeStyle: 'short', hour12: true }) : ''
}

/** 'HH:MM' (24h, from the API's calendar endpoints) → '1:30 PM' / '10 AM'. */
export function fmtClock(hhmm) {
  const [h, m] = String(hhmm).split(':').map(Number)
  if (!Number.isInteger(h)) return hhmm
  const ampm = h < 12 || h === 24 ? 'AM' : 'PM' // 24:00 = the midnight clamp on multi-day events
  const h12 = h % 12 === 0 ? 12 : h % 12
  return m ? `${h12}:${String(m).padStart(2, '0')} ${ampm}` : `${h12} ${ampm}`
}
